import React from 'react'
import SettingsMetaData from '../../../../Components/Hooks/useSettingsMetaData'

function Unit() {
  return (
    <SettingsMetaData propertyName={"unit_equipments"} viewPropertyName={"Unit"} />

  )
}

export default Unit